import Style from './ConfirmationEmailBrick.module.less';
import FJNav from '../common/FJNav/FJNav';
import FJLocalStore from '../../store/FJLocalStore';
import FJInput from '../common/FJInput/FJInput';
import FJButton from '../common/FJButton/FJButton';
import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import FJErrTip from '../common/FJErrTip/FJErrTip';
import useLocalStore from '../../hooks/useLocalStore';
import FJUtil from '../../util/FJUtil';

const ConfirmationEmailBrick = props => {
    useLocalStore();
    let { value, confirmClick, onChange, stepChange, popupType, active } = props;
    // const [confirm,SetConfirm]=useState(value)
    const [load, setLoad] = useState(false);
    const [errTip, setErrTip] = useState(null);
    const inputRef = useRef();
    let _navClick = () => {
        stepChange('default');
    };
    let _onChange = value => {
        _clean();
        onChange(value);
        // SetConfirm(value)
    };
    let _clean = () => {
        inputRef.current.setInit();
        setErrTip(null);
    };
    let _formatCheck = useCallback(() => {
        // let reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
        let reg = /^((?!@)(?!\s).)+[@][0-9a-zA-Z_.-]+([.][a-zA-Z0-9]+){1,2}$/;
        let res = true;
        if (value.length === 0) {
            inputRef.current.setErrorMessage(FJLocalStore._('Enter-Email-Address-here'));
            res = false;
            return res;
        } else {
            inputRef.current.setInit();
        }
        if (reg.test(value)) {
            inputRef.current.setInit();
        } else {
            inputRef.current.setErrorMessage(FJLocalStore._('enter-valid-email'));
            res = false;
            return res;
        }
        return res;
    }, [value]);

    let _nextClick = useCallback(() => {
        let result = _formatCheck();
        if (!result) {
            return;
        }
        setLoad(true);
        const obj = {
            email: value,
            type: 2,
            code_language: FJLocalStore.currentTag(),
        };
        confirmClick(obj, option => {
            setLoad(false);
            if (option.networkFail) {
                setErrTip(option.errTip);
            } else if (option.result === true) {
                setErrTip(null);
            } else {
                setErrTip(option.errTip);
            }
        });
    }, [value, _formatCheck, confirmClick]);

    let _enterConfirm = useCallback(
        event => {
            if (event.keyCode === 13) {
                _nextClick();
            }
        },
        [_nextClick],
    );

    useEffect(() => {
        FJUtil.addEvent(window, 'keydown', _enterConfirm);
        return () => {
            FJUtil.removeEvent(window, 'keydown', _enterConfirm);
        };
    }, [_enterConfirm]);
    return (
        <div
            className={classNames(Style.confirm_box, {
                [Style.confirm_box_show]: active,
                [Style.confirm_box_popup]: popupType,
            })}
        >
            <FJNav title={FJLocalStore._('forget-password')} onClick={_navClick} popupType={popupType} />

            <p className={Style.curTip} dangerouslySetInnerHTML={{ __html: FJLocalStore._('will-send-code') }} />
            <FJInput
                value={value}
                onChange={_onChange}
                placeholder={FJLocalStore._('Enter-Email-Address-here')}
                type='text'
                className={Style.inputMargin}
                inputClassName={Style.input}
                ref={inputRef}
                popupType={popupType}
                preventAutoComplete
                // hasRightIcon
            />
            {/*<input type='password' readOnly={true} style={{height: '0px'}}/>*/}
            <FJErrTip errTip={errTip} />
            <FJButton
                text={FJLocalStore._('next')}
                small={popupType}
                className={Style.submit_btn}
                isLoading={load}
                onClick={_nextClick}
            />
            <input type='password' style={{ height: '0', opacity: 0 }} />
        </div>
    );
};
export default ConfirmationEmailBrick;
